var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLevel8(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 84,
    height: 84,
    viewBox: "0 0 84 84",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#d65d05;}.b,.c{fill:none;stroke:#003c71;stroke-linecap:round;stroke-width:3px;}.b{stroke-miterlimit:10;}.c{stroke-linejoin:round;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1185 -524)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M42,0A42,42,0,1,1,0,42,42,42,0,0,1,42,0Z",
    transform: "translate(1185 524)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(720.599 529.122)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M525.284,55.361c-3.382-6.57-8.348-11.46-18.645-11.46s-16.13,5.73-18.644,11.46"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M487.995,28.722l12.929,1.728-10.7-6.912"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M524.6,28.722,511.668,30.45l11.667-6.912"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLevel8);
export default __webpack_public_path__ + "static/media/level8.abfe7e5abfa14266cb449c79ae428041.svg";
export { ForwardRef as ReactComponent };